import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "faded-top no-scrollbar" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.model)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "project-card",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.navigateToProject && _ctx.navigateToProject(...args)))
      }, [
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.model.project), { "is-preview": _ctx.isPreview }, null, 8, ["is-preview"]))
        ])
      ]))
    : _createCommentVNode("", true)
}